import { render } from "./Entries.vue?vue&type=template&id=4b3e4a91"
import script from "./Entries.vue?vue&type=script&lang=js"
export * from "./Entries.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__